import * as types from 'src/js/constants/actionTypes';
import {wrapCall} from "src/js/utils/serviceUtils";
import {api} from "src/js/utils/services";

export const fetchHome = () => {
  return wrapCall(
    api.get(`/landing`),
    types.FETCH_HOME
  );
}
